'use client';
import type { SVGProps } from "react";
import type { FC } from 'react';
import type { IconProps } from '../utils/type';
import { SvgIconWrapper } from '../utils/svg-icon-wrapper';
/**
 * Auto-generated icon component: Do not change this component manually.
 * Config file: customSvgrTemplate.js
 */
const SvgBase: FC<IconProps> = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}><path fill="currentColor" fillRule="evenodd" d="M20.595 4.493c.947.27 1.692 1.07 1.945 2.084.46 1.838.46 5.673.46 5.673s0 3.835-.46 5.674c-.253 1.014-.998 1.812-1.945 2.084C18.88 20.5 12 20.5 12 20.5s-6.88 0-8.595-.492c-.947-.272-1.692-1.07-1.945-2.084C1 16.085 1 12.25 1 12.25s0-3.835.46-5.673c.253-1.015.998-1.813 1.945-2.084C5.12 4 12 4 12 4s6.88 0 8.595.493M9.938 9.022v7.174l5.5-3.587z" clipRule="evenodd" /></svg>;
const IconSocialYoutube = ({
  $size,
  $color,
  className,
  ...rest
}: IconProps) => <SvgIconWrapper $size={$size} $color={$color} className={className}><SvgBase {...rest} /></SvgIconWrapper>;
export default IconSocialYoutube;